import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Checkbox } from '@mui/material';
import { Link } from "react-router-dom";

import { Text18 } from '../../../ui/Text18';
import { moneyFormatterMDL } from '../../../helpers/moneyFormatted';
import { Offers } from '../../../types';
import { InsuranceContext } from '../../../context/insuranceContext';
import { devUrl } from '../../../constants/index';
import { 
  Wrapper, 
  AcceptLabel, 
  AmountWrapper, 
  AmountText, 
  ButtonWrapper, 
  AcceptWrapper 
} from '../index.style';


type Props = {
  selectedOffer: Array<Offers>;
};

const BottomConfirm: React.FC<Props> = ({ selectedOffer }) => {
  const { t } = useTranslation();
  const [accepted, setAccepted] = useState(false);

  const sum = selectedOffer?.[0]?.amount?.mdl || 0;
  const { insurance } = useContext(InsuranceContext);
  const isDev = process.env.NODE_ENV === 'development'; 
  const baseURL = isDev ? `${devUrl}api/create-insurance` : '/api/create-insurance';  

  // console.log('context insurance ', insurance);

  const handleSendData = async () => {
    const response = await fetch(baseURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(insurance)
    });
    const result = await response.json();
    window.location.replace(result?.payment_link);   
  }

  return (
    <Wrapper>
      <AcceptWrapper>
        <Checkbox
          checked={accepted}
          onChange={() => setAccepted(!accepted)}
        />
        <AcceptLabel>
          {t('confirm_personal')}
          <Link target='_blank' to='/terms-and-conditions'>{t('confirm_terms')}</Link>
          {t('and')}
          <Link target='_blank' to='/personal-data-policy'>{t('confirm_policy')}</Link>
          {t('on_site')}
        </AcceptLabel>
      </AcceptWrapper>          
      <AmountWrapper>
        <AmountText>{`${t('total')}: ${moneyFormatterMDL.format(
          sum
        )}`}</AmountText>
      </AmountWrapper>
      <ButtonWrapper>
        <Button 
          disabled={!accepted}
          variant='contained'
          onClick={handleSendData}
        >
          <Text18>{t('pay')}</Text18>
        </Button>
      </ButtonWrapper>
    </Wrapper>
  );
};

export default BottomConfirm;
